export const FETCH_START = 'EXAM_FETCH_START';
export const FETCH_FAIL = 'EXAM_FETCH_FAIL';
export const EXAM_CREATED = 'EXAM_CREATED';
export const TIMER_STARTED = 'EXAM_TIMER_STARTED';
export const QUESTION_ANSWERED = 'EXAM_QUESTION_ANSWERED';
export const QUESTION_VIEWED = 'EXAM_QUESTION_VIEWED';
export const EXAM_REGISTERED = 'EXAM_EXAM_REGISTERED';
